import { Key, IHasKey, Entity } from '@kpd/framework-ngx';
import { Permissionset } from './permissionset';
import { Role } from './role';
import { User } from './user';

export class Permission extends Entity implements IHasKey {
  key: Key<string>;
  id: string;
  name: string;
  description: string;
  isDeprecated: boolean;
  deprecatedMessage: string;

  application?: string;
  permissionSets?: Permissionset[];
  roles?: Role[];
  users?: User[];

  constructor(dto?: any) {
    super(dto);
  }

  getDisplayName(): string {
    if (!this.name) {
      return '';
    }
    let displayName = this.name;
    if (this.description) {
      displayName += ` - ${this.description}`;
    }
    // this.deprecated = true;
    return displayName;
  }

  setKey(dto: any): void {
    this.key = new Key<string>(dto.id);
  }

  clone(): Permission {
    const clone = new Permission();
    Object.assign(clone, this);
    return clone;
  }
}
